export { default as LocaleSelect } from "./components/LocaleSelect";
